import { render, staticRenderFns } from "./df-section-feautured.vue?vue&type=template&id=330218c5"
import script from "./df-section-feautured.ts?vue&type=script&lang=js&external"
export * from "./df-section-feautured.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports